import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { memo, useEffect } from 'react';
import dayjs from 'dayjs';
import Categories from './Categories';
import Img from '../common/Img';
import styles from '../../../styles/components/section/stories/Main.module.scss';

const Main = memo(({ stories, category }) => {
    const router = useRouter();
    useEffect(() => {
        // hover
        const html = document.querySelector('html');
        const arrowLinks = document.querySelectorAll('.js-hover__stories');
        const options = [];
        const eventHandler = {
            mouseEnter: null,
            mouseLeave: null,
        };
        const _defaultDuration = {
            in: 600,
            out: 600,
        };
        function _setFlag() {
            const length = arrowLinks.length;
            for (let i = length; i--; ) {
                options[i] = {
                    isHovering: false,
                    isAnimating: false,
                };
                let target = arrowLinks[i];
                target.setAttribute('data-hover-num', i);
            }
        }
        _setFlag();
        function _setEventListener() {
            eventHandler.mouseEnter = (e) => {
                e.preventDefault();
                _onMouseEnter(e.currentTarget);
            };
            eventHandler.mouseLeave = (e) => {
                e.preventDefault();
                _onMouseLeave(e.currentTarget);
            };
            [].forEach.call(arrowLinks, ($el) => {
                $el.addEventListener(
                    'mouseenter',
                    eventHandler.mouseEnter,
                    false
                );
                $el.addEventListener(
                    'mouseleave',
                    eventHandler.mouseLeave,
                    false
                );
            });
        }
        _setEventListener();
        function _onMouseEnter($this) {
            const num = Number($this.dataset['hoverNum']);
            options[num].isHovering = true;
            if (!options[num].isAnimating) {
                _startMouseEnter($this, num);
            }
        }
        function _onMouseLeave($this) {
            const num = Number($this.dataset[`hoverNum`]);
            options[num].isHovering = false;
            if (!options[num].isAnimating) {
                _startMouseLeave($this, num);
            }
        }
        function _startMouseEnter($this, num) {
            options[num].isAnimating = true;
            // if (!html.classList.contains('deviceMobile')) {
            $this.classList.add('is-hover');
            // }
            const time =
                Number($this.dataset['hoverInTime']) || _defaultDuration.in;
            setTimeout(() => {
                _completeMouseEnter($this, num);
            }, time);
        }
        function _startMouseLeave($this, num) {
            options[num].isAnimating = true;
            // if (!html.classList.contains('deviceMobile')) {
            $this.classList.remove('is-hover');
            $this.classList.add('is-hover-out');
            // }
            const time =
                Number($this.dataset['hoverOutTime']) || _defaultDuration.out;
            setTimeout(() => {
                _completeMouseLeave($this, num);
            }, time);
        }
        function _completeMouseEnter($this, num) {
            options[num].isAnimating = false;
            if (!options[num].isHovering) {
                _startMouseLeave($this, num);
            }
        }
        function _completeMouseLeave($this, num) {
            options[num].isAnimating = false;
            // if (!html.classList.contains('deviceMobile')) {
            $this.classList.remove('is-hover-out');
            // }
            if (options[num].isHovering) {
                _startMouseEnter($this, num);
            }
        }
    }, [router]);

    return (
        <div className={styles.main}>
            <Categories spNone={true} stories={stories} />
            <div className={styles.container}>
                <div className={styles.wrapper}>
                    <div className={styles.head}>
                        <h2 className={styles.headTitle}>
                            {category ? category : 'すべての記事'}
                        </h2>
                    </div>
                    <div className={styles.body}>
                        <ul className={styles.bodyList}>
                            {stories.map((data, i) => {
                                return (
                                    <li
                                        className={styles.bodyItem}
                                        key={data.sys.id}
                                    >
                                        <Link
                                            href={
                                                `/stories/` + data.fields.slug
                                            }
                                        >
                                            <a
                                                className={`${styles.bodyItemLink} js-hover__stories`}
                                            >
                                                <div
                                                    className={
                                                        styles.bodyItemImg
                                                    }
                                                >
                                                    {/* <Image
                                                        className={`${styles.bodyItemImgInside} js-hover__img`}
                                                        src={
                                                            `https:` +
                                                            data.fields.image
                                                                .fields.file
                                                                .url +
                                                            `?fm=webp&q=50`
                                                        }
                                                        //    src={data.src}
                                                        layout="fill"
                                                        objectFit="cover"
                                                        //    layout="responsive"
                                                        //    width={450}
                                                        //    height={450}
                                                        alt={data.fields.alt}
                                                        //    alt={data.title}
                                                        // loading={'eager'}
                                                        placeholder="blur"
                                                        blurDataURL={
                                                            `https:` +
                                                            data.fields.image
                                                                .fields.file
                                                                .url +
                                                            `?fm=webp&q=10`
                                                        }
                                                    /> */}
                                                    {data.fields.image ? (
                                                        <Img
                                                            hover={true}
                                                            src={
                                                                `https:` +
                                                                data.fields
                                                                    .image
                                                                    .fields
                                                                    ?.file.url +
                                                                `?fm=webp&q=50`
                                                            }
                                                            alt={
                                                                data.fields.alt
                                                            }
                                                        />
                                                    ) : (
                                                        <Img
                                                            hover={true}
                                                            src="/image/stories/post/preset.jpg"
                                                            alt={
                                                                data.fields.alt
                                                            }
                                                        />
                                                    )}
                                                </div>
                                            </a>
                                        </Link>
                                        <div className={styles.bodyItemContent}>
                                            <div
                                                className={
                                                    styles.bodyItemContentHead
                                                }
                                            >
                                                <Link
                                                    href={
                                                        `/stories/` +
                                                        data.fields.slug
                                                    }
                                                >
                                                    <a
                                                        className={
                                                            styles.bodyItemContentHeadCategory
                                                        }
                                                    >
                                                        {data.fields.category}
                                                    </a>
                                                </Link>
                                                <span
                                                    className={
                                                        styles.bodyItemContentHeadDate
                                                    }
                                                >
                                                    {dayjs(
                                                        data.fields.publishedAt
                                                    ).format('YYYY-MM-DD')}
                                                </span>
                                            </div>
                                            <span
                                                className={
                                                    styles.bodyItemContentTitle
                                                }
                                            >
                                                {data.fields.title}
                                            </span>
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
});

Main.displayName = 'Main';

export default Main;
